export default __webpack_public_path__ + "static/media/Wrap of the Shivering Stars.ecb642f6.jpg";